/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './campaign-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LineItemBulkActionService} from '../line-item/line-item-bulk-action.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-campaign-list-page',
  template
})
export class CampaignListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.campaigns.campaign';
  readonly productItemStateName = 'app.adm.products.product';
  readonly userItemStateName = 'app.adm.users.user';

  readonly columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'userState'},
    {param: 'executionState'},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'objectives', numeric: true},
    {param: 'updateTime'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly lineItemBulkActionService: LineItemBulkActionService
  ) {
    super(LocalNetworkProfile);
  }

  filtersResolved(): boolean {
    const list = this.list;
    if (!list) {
      return true;
    }
    return !!(list.selectInQuery?.$resolved);
  }

  userLinkDisabled(): boolean {
    const perms = this.list?.perms || {};
    return perms.MANAGE_SYSTEM !== true
      && perms.AX_ADVERTISER_ADMIN !== true
      && perms.AX_ADVERTISER_TEAM_ADMIN !== true;
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    if (!this.list.bulkAction) {
      this.list.bulkAction = this.lineItemBulkActionService.createBulkAction(this.list);
    }
  }
}
